import {
  Box,
  Container,
  Dialog as BaseDialog,
  Drawer,
  IconButton,
  ImageList,
  ImageListItem,
  Paper,
  useMediaQuery,
  withStyles,
} from "@material-ui/core";
import {
  ArrowBackIosRounded,
  ArrowForwardIosRounded,
  Close,
} from "@material-ui/icons";
import React, { useState } from "react";
import SwipeableViews from "react-swipeable-views";
import useStyles from "../../styles/components/DialogImageRoomRate";

const StyledPaperSlider = withStyles({
  root: {
    bottom: "0px",
    position: "fixed",
    marginBottom: "unset",
    margin: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    maxWidth: 444,
    width: "100%",
    height: "100vh",
    maxHeight: "none !important",
    borderRadius: 0,
    backgroundColor: "transparent !important",
  },
})(Paper);

interface DialogRoomRateType {
  onClose: () => void;
  open: boolean;
  images: string[];
}

const DialogImageRoomRate = (props: DialogRoomRateType) => {
  const classes = useStyles();
  const { onClose, images, open } = props;
  const extraSmall = useMediaQuery("(max-width:416px)");
  const [showSliderImage, setShowSliderImage] = useState(false);
  const [indexImg, setIndexImg] = useState(0);

  const handlePrev = () => {
    if (indexImg === 0) {
      setIndexImg(images?.length - 1);
    } else {
      setIndexImg(indexImg - 1);
    }
  };

  const handleNext = () => {
    if (indexImg + 1 === images?.length) {
      setIndexImg(0);
    } else {
      setIndexImg(indexImg + 1);
    }
  };

  return (
    <Drawer
      open={open}
      onClose={onClose}
      anchor="bottom"
      className={classes.listImageDrawer}
    >
      <Container maxWidth="xs" className={classes.root}>
        <Box height="100%">
          <Box
            className={classes.listImageWrapper}
            style={{ height: images?.length < 15 ? "100%" : "none" }}
          >
            <Box textAlign="right" mb="16px">
              <Close className={classes.icon} onClick={onClose} />
            </Box>
            <ImageList rowHeight={extraSmall ? 100 : 130} cols={3} gap={8}>
              {images.map((image, index) => (
                <ImageListItem key={index}>
                  <img
                    src={image}
                    alt="room-image"
                    className={classes.roomImage}
                    onClick={() => {
                      setShowSliderImage(true);
                      setIndexImg(index);
                    }}
                  />
                </ImageListItem>
              ))}
            </ImageList>
          </Box>
          <BaseDialog
            onClose={() => setShowSliderImage(false)}
            open={showSliderImage}
            disableScrollLock={true}
            PaperComponent={StyledPaperSlider}
            aria-labelledby="draggable-dialog-title"
          >
            <Box className={classes.swipeableViewWrapper}>
              <SwipeableViews
                index={indexImg}
                onChangeIndex={(index) => setIndexImg(index)}
                animateTransitions={false}
              >
                {images.map((image, index) => (
                  <>
                    <Box textAlign="right" mb="16px">
                      <Close
                        className={classes.icon}
                        onClick={() => setShowSliderImage(false)}
                      />
                    </Box>
                    <Box position="relative" display="flex" alignItems="center">
                      <img
                        src={image}
                        key={index}
                        width="100%"
                        alt="room-image"
                        className={classes.viewRoomImage}
                      />
                      <Box className={classes.arrowWrapper}>
                        <IconButton onClick={handlePrev}>
                          <ArrowBackIosRounded className={classes.icon} />
                        </IconButton>
                        <IconButton onClick={handleNext}>
                          <ArrowForwardIosRounded className={classes.icon} />
                        </IconButton>
                      </Box>
                    </Box>
                  </>
                ))}
              </SwipeableViews>
            </Box>
          </BaseDialog>
        </Box>
      </Container>
    </Drawer>
  );
};

export default DialogImageRoomRate;
